const whenReadyPromiseUpdateQtyControl =
  window.CornerWebComponentsAPI?.whenReady?.call(window.CornerWebComponentsAPI) ||
  new Promise(resolve => {
    // Fallback: API not loaded yet, queue the callback
    window.CORNER_PENDING_EXTENDED_COMPONENTS = window.CORNER_PENDING_EXTENDED_COMPONENTS || [];
    window.CORNER_PENDING_EXTENDED_COMPONENTS.push(resolve);
  });

whenReadyPromiseUpdateQtyControl.then(() => {
  window.CornerWebComponentsAPI.extendComponent(
    'CornerCartLineItem',
    Base =>
      class extends Base {
        renderQtyControl() {
          const customerTags = window?.corner?.sessionData?.customer?.tags || [];
          const cornerHideQty = customerTags.includes('wholesale');
          if (cornerHideQty) {
            return this
              .html`<p class=" text-sm md:text-base text-cowi-primary-type text-center font-bold " aria-label="Current Item Quantity" data-testid="corner-cowi-cart-item-qty-${this.index}">
               QTY : ${this.quantity}
            </p>`;
          }
          return super.renderQtyControl();
        }
      },
  );
});
